import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import './component.scss';
import { find, addClass, getParent } from '@fretadao/f-js-dom';
import { API } from 'src/api';

const TIME_CONSIDERATION = {
  'near': 'text-green',
  'medium': 'text-yellow',
  'far': 'text-red'
}

application.register(
  'travel-information',
  class extends Controller {
    static targets = ['timeDistance', 'time'];

    connect() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { if(entry.isIntersecting) this.updateDistance(entry.target) })
      }, { threshold: [0] });

      this.timeDistanceTargets.forEach((target) => observer.observe(target));
      this.timeTargets.forEach((target) => observer.observe(target));
    }

    updateDistance(target) {
      if (target.getAttribute('distance-updated')) return;
      target.setAttribute('distance-updated', true);

      const origin = target.dataset.origin;
      const destination = target.dataset.destination;
      const provider = target.dataset.provider;
      const csrfToken = find("meta[name='csrf-token']").content;
      const isDesktopVision = target.dataset.travelInformationTarget === 'timeDistance';
      const p = document.createElement('p');

      API.distanceBetweenOriginAndDestination.getDistance(origin, destination, provider, csrfToken).then(
        (response) => {
          if (response.status == 200) {
            const distance = response.data.meters;
            const time = response.data.minutes;
            const distanceFromDestination = response.data.time_consideration;
            let icon = null;

            if (isDesktopVision) {
              icon = find('.fas.fa-walking', getParent(target, 3));

              addClass(p, ['text-sm', 'max-w-265', 'TravelInformation-desktopText']);
              target.classList.remove('bg-gray-ltr', 'h-4', 'w-32', 'rounded-xl', 'animate-pulse');
              p.innerText = `${time} min (${distance} metros)`;
              target.appendChild(p);
            } else {
              icon = find('.fas.fa-walking', getParent(target));

              target.classList.remove('bg-gray-ltr', 'h-4', 'w-8', 'rounded-xl', 'animate-pulse');
              p.innerText = `${time} min`;
              target.appendChild(p);
            }

            icon.classList.add(TIME_CONSIDERATION[distanceFromDestination]);
            icon.classList.remove('text-gray-ltr', 'animate-pulse');
          }
        }
      );
    }
  }
);
